import Loadable from 'react-loadable';
import Loading from '@src/components/loading';

const resolveComponent = (loader: () => Promise<any>) => {
  return Loadable({ loader, loading: Loading });
};

export default resolveComponent;
